export default "__VITE_ASSET__Dr$fCLy1__"